// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1Bmuh","selects":"Documents_selects__30ZyM"};